import styled from 'styled-components';
import { Table, Form, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';

import { ClaimDocumentFileDownloadService } from '../../../domain';

const TableContainer = styled.div`
    overflow-x: auto;
    white-space: nowrap;
    padding: 0;
    margin: 0;
    width: 100%;
`;

const Title = styled.h1`
    font-size: 34px;
    font-weight: 700;
`;

export default function ShowDetails({ formData, setFormData, docPerClaimTypes, setLoading }) {
    const _ClaimDocumentFileDownloadService = new ClaimDocumentFileDownloadService();

    const downloadFile = async (event) => {
        try {
            const payload = {
                directoryName: event.documentDir,
                documentName: event.documentName
            };
            setLoading(true);
            const file = await _ClaimDocumentFileDownloadService.execute(payload);

            if (!file.file) {
                Swal.fire({
                    text: 'Sorry. Something went wrong. Please try again later.',
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                setLoading(false);
                return;
            }

            const link = document.createElement('a');
            link.href = file.file;
            // link.target = '_blank';
            link.download = event.documentName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            console.log('file', file);
            setLoading(false);
        } catch (error) {
            Swal.fire({
                text: 'Sorry. Something went wrong. Please try again later.',
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
            setLoading(false);
        }
    };

    return (
        <div>
            <br />

            <Row>
                <Title>Documents</Title>
            </Row>

            <TableContainer>
                <Table bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Required Documents</th>
                            <th>File Preview</th>
                            <th>Status</th>
                            <th>Remarks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formData?.claimsPayload?.claimDocuments &&
                        formData?.claimsPayload.claimDocuments.length > 0 ? (
                            formData?.claimsPayload.claimDocuments.map((item, index) => {
                                const documentDescription = docPerClaimTypes?.find(
                                    (docType) => docType.mtnDocumentTypeId === item.mtnDocumentTypeId
                                )?.documentDesc;
                                return (
                                    <tr key={'claimItem_' + index}>
                                        <td
                                            id="document-description"
                                            style={{
                                                wordWrap: 'break-word',
                                                wordBreak: 'break-word',
                                                whiteSpace: 'normal'
                                            }}
                                        >
                                            {documentDescription}
                                        </td>
                                        <td
                                            id="file-preview"
                                            style={{
                                                paddingLeft: '20px',
                                                wordWrap: 'break-word',
                                                wordBreak: 'break-word',
                                                whiteSpace: 'normal'
                                            }}
                                        >
                                            {!!item?.attachedDocuments?.length && (
                                                <div>
                                                    {item.attachedDocuments.map((s3UploadedDocs) => {
                                                        return (
                                                            <li key={`s3Uploaded_${s3UploadedDocs.id}`}>
                                                                <span>
                                                                    <a
                                                                        href="#"
                                                                        className="me-3"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            downloadFile(s3UploadedDocs);
                                                                        }}
                                                                    >
                                                                        {s3UploadedDocs.documentName}
                                                                    </a>
                                                                </span>
                                                                <br />
                                                            </li>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            {!!item?.attachedDocuments?.length && (
                                                <Form.Select
                                                    value={item.attachedDocuments[0].status}
                                                    style={{ width: '150px' }}
                                                    onChange={(e) => {
                                                        const attachedDocs = [...formData.claimsPayload.claimDocuments];
                                                        const newClaimDocumentsRemarks = item.attachedDocuments.map(
                                                            (item) => {
                                                                return { ...item, status: e.target.value };
                                                            }
                                                        );
                                                        attachedDocs[index].attachedDocuments =
                                                            newClaimDocumentsRemarks;
                                                        setFormData({
                                                            ...formData,
                                                            claimsPayload: {
                                                                ...formData.claimsPayload,
                                                                claimDocuments: attachedDocs
                                                            }
                                                        });
                                                    }}
                                                >
                                                    <option value="Pending">Pending</option>
                                                    <option value="For Review">For Review</option>
                                                    <option value="Completed">Completed</option>
                                                </Form.Select>
                                            )}
                                        </td>

                                        <td>
                                            {!!item?.attachedDocuments?.length && (
                                                <Form.Control
                                                    type="text"
                                                    value={item.attachedDocuments[0].remarks}
                                                    onChange={(e) => {
                                                        const attachedDocs = [...formData.claimsPayload.claimDocuments];
                                                        const newClaimDocumentsRemarks = item.attachedDocuments.map(
                                                            (item) => {
                                                                return { ...item, remarks: e.target.value };
                                                            }
                                                        );
                                                        attachedDocs[index].attachedDocuments =
                                                            newClaimDocumentsRemarks;
                                                        setFormData({
                                                            ...formData,
                                                            claimsPayload: {
                                                                ...formData.claimsPayload,
                                                                claimDocuments: attachedDocs
                                                            }
                                                        });
                                                    }}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr className="text-center">
                                <td colSpan="3">No documents available.</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </TableContainer>
        </div>
    );
}
